import cl from './ProductCard.module.css';
import { Link, NavLink, useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import Comments from '../../../Comments/Comments';
import { animateScroll as scroll } from 'react-scroll';

const ProductCard = (props) => {
  useEffect(() => {
    scroll.scrollToTop();
  }, []);

  const productPath = useParams().path;
  const product = props.productsData.find(
    (product) => product.path === encodeURIComponent(productPath)
  );
  const image = product.images ? product.images[0] : null;
  const [mainImage, setMainImage] = useState(image);
  const [isAdded, setIsAdded] = useState(false);

  let onClick = () => {
    props.onAdd(props);
    setIsAdded(true);
  };

  useEffect(() => {
    if (ifChecked()) setIsAdded(true);
  }, []);

  function ifChecked() {
    if (props.cartItems.some((item) => item.productId === props.productId)) {
      return true;
    } else {
      return false;
    }
  }

  const onMouseOver = (img) => () => {
    setMainImage(img);
  };
  let productDescrImages = product.imagesAbout?.map((p, i) => (
    <img alt="info" className={cl.description_image} src={p} key={i} />
  ));
  let newPrice = ((product.oldPrice * (100 - product.discount)) / 100).toFixed(
    2
  );

  return (
    <section
      itemScope
      itemType="https://schema.org/Product"
      className="section"
    >
      <div className={cl.productcard}>
        <div className={cl.productcard_images}>
          <div className={cl.mini_images}>
            {product.images?.map((image, i) => (
              <img
                src={image}
                itemProp="image"
                onMouseOver={onMouseOver(image)}
                alt=""
                key={i}
              />
            ))}
          </div>
          <img className={cl.big_image} src={mainImage} alt="" />
        </div>
        <div className={cl.main_productcard}>
          <h4 className={cl.main_productcard_name} itemProp="name">
            {product.name}
          </h4>
          <p
            className={cl.main_productcard_price}
            itemProp="offers"
            itemScope
            itemType="https://schema.org/Offer"
          >
            <span itemProp="price">
              {product.currency}
              {newPrice}
            </span>
          </p>
          <div className={cl.main_productcard_recomended}>
            <svg
              className={cl.main_productcard_recomended_svg}
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title />
              <g data-name="Layer 2" id="Layer_2">
                <path d="M12,5c-6.54,0-9.76,6.29-9.89,6.55L1.88,12l.22.45C2.24,12.71,5.46,19,12,19s9.76-6.29,9.89-6.55l.22-.45-.22-.45C21.76,11.29,18.54,5,12,5Zm0,12c-4.38,0-7-3.7-7.85-5C5,10.7,7.62,7,12,7s7,3.7,7.85,5C19,13.3,16.38,17,12,17Z" />
                <path d="M12,8a4,4,0,1,0,4,4A4,4,0,0,0,12,8Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,12,14Z" />
              </g>
            </svg>
            {Math.floor(Math.random() * (200 - 100 + 1)) + 100} Persone stanno
            visualizzando questo in questo momento!
          </div>
          <div className={cl.main_productcard_bottons}>
            <NavLink style={{ display: 'flex' }} to="/products">
              <button
                className={cl.main_productcard_buynow}
                onClick={() => props.onBuyItNow(product)}
              >
                Acquista ora
              </button>
            </NavLink>
          </div>
          <div className={cl.description} itemProp="description">
            <p
              style={{
                fontWeight: '800',
                fontSize: '24px',
                marginTop: '20px',
                marginBottom: '10px',
              }}
            >
              Informazioni sul prodotto
            </p>
            {product.description}
          </div>
        </div>
      </div>
      {product.info ? (
        <div itemProp="description" className={cl.table_description}>
          <table style={{ width: '100%' }}>
            <tbody>
              {Object.entries(product.info).map(([key, value]) => (
                <tr key={key}>
                  <td
                    style={{
                      fontWeight: 'bold',
                      padding: '0.5rem 2rem 0.5rem 0.5rem',
                    }}
                  >
                    {key}
                  </td>
                  <td style={{ padding: '0.5rem' }}>{value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <> </>
      )}
      {product.features ? (
        <div
          itemProp="description"
          style={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            margin: '3rem 0',
          }}
        >
          <p
            style={{
              marginBottom: '1.5rem',
              fontSize: '1.5rem',
              fontWeight: 'bold',
              textAlign: 'center',
            }}
          >
            Caratteristiche del prodotto
          </p>
          <ul className={cl.product_features}>
            {product.features?.map((feature, i) => (
              <li style={{ margin: '0.5rem 0' }} key={i}>
                {feature}
              </li>
            ))}
          </ul>
        </div>
      ) : null}

      <div className={cl.description}>{productDescrImages}</div>
      <Comments comments={product.comments} rating={product.rating} />
    </section>
  );
};

export default ProductCard;
